export default __webpack_public_path__ + "static/media/WhatIsLaboratory.80ce8569.PNG";